export default "__VITE_ASSET__CoHqT6Sr__"